import { inject, Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { nonNullable } from '@rma/generic/rxjs/operators/non-nullable';
import { PublicUserContextService } from '@rma/public/accounts/user';
import { Environment } from '@rma/public/generic/util/environment';
import { map } from 'rxjs';
import { TrackJS } from 'trackjs';

@UntilDestroy()
@Injectable({
  providedIn: 'root',
})
export class TrackJsService {
  private readonly userService = inject(PublicUserContextService);
  private readonly environment = inject(Environment);

  initialise() {
    if (!TrackJS.isInstalled()) {
      return;
    }

    const { language, version } = this.environment;

    TrackJS.addMetadata('locale', language.locale);

    TrackJS.configure({ version });
    this.userService.currentUser$
      .pipe(
        nonNullable(),
        map(({ userId }) => ({ version, userId })),
        untilDestroyed(this),
      )
      .subscribe((config) => {
        TrackJS.configure(config);
      });
  }
}
